<div class="mt-5">
    <div class="section">

        <div class="section-content">
            <h3 class="page-subheader">{{'CLIENT_DECLARATIONS_CONDITIONS' | translate}}</h3>
            <p>{{'CLIENT_DECLARATION_INFO' | translate}}</p>
            <div class="form-row">
                <div class="col">
                    <app-checkbox [(ngModel)]="offer.additionalData.clauseMap[clauseType.CLIENT_DECLARATION_1]"
                                  [disabled]="readonly"
                                  [errorStateMatcher]="matchers[clauseType.CLIENT_DECLARATION_1]">{{'CLIENT_DECLARATION_1' | translate}}
                        <a href="/resources/Oswiadczenie_ADO.pdf" target="_blank"
                           class="link link-accent">{{'READ_MORE' | translate}}</a>
                    </app-checkbox>
                </div>

            </div>
            <div class="form-row">
                <div class="col">
                    <app-checkbox [(ngModel)]="offer.additionalData.clauseMap[clauseType.CLIENT_DECLARATION_2]"
                                  [disabled]="readonly"
                                  [errorStateMatcher]="matchers[clauseType.CLIENT_DECLARATION_2]">{{'CLIENT_DECLARATION_2' | translate}}
                    </app-checkbox>
                </div>
            </div>

            <div class="separator"></div>

            <h3 class="page-subheader">{{'AGENT_DECLARATIONS' | translate}}</h3>

            <div class="form-row">
                <div class="col">
                    <app-checkbox [(ngModel)]="agentChecked" [disabled]="readonly">
                        {{'SELECT_ALL_DECLARATIONS' | translate}}
                    </app-checkbox>
                </div>
            </div>

            <hr>

            <div class="form-row">
                <div class="col">
                    <app-checkbox [(ngModel)]="offer.additionalData.clauseMap[clauseType.AGENT_DECLARATION_1]"
                                  [disabled]="readonly"
                                  [errorStateMatcher]="matchers[clauseType.AGENT_DECLARATION_1]">{{'AGENT_DECLARATION_1' | translate}}
                    </app-checkbox>
                </div>
            </div>

            <div class="form-row">
                <div class="col">
                    <app-checkbox [(ngModel)]="offer.additionalData.clauseMap[clauseType.AGENT_DECLARATION_2]"
                                  [disabled]="readonly"
                                  [errorStateMatcher]="matchers[clauseType.AGENT_DECLARATION_2]">{{'AGENT_DECLARATION_2' | translate}}
                    </app-checkbox>
                </div>
            </div>

            <div class="form-row">
                <div class="col">
                    <app-checkbox [(ngModel)]="offer.additionalData.clauseMap[clauseType.AGENT_DECLARATION_3]"
                                  [disabled]="readonly"
                                  [errorStateMatcher]="matchers[clauseType.AGENT_DECLARATION_3]">{{'AGENT_DECLARATION_3' | translate}}
                    </app-checkbox>
                </div>
            </div>


            <h3 class="page-subheader">{{'CLIENT_CONDITIONS' | translate}}</h3>

            <p>{{'CLIENT_CONDITION_1' | translate}}</p>
            <div class="form-row">
                <div class="col">
                    <app-checkbox
                            [(ngModel)]="offer.additionalData.clauseMap[clauseType.CLIENT_CONDITION_1]"
                            [disabled]="readonly"
                            [errorStateMatcher]="matchers[clauseType.CLIENT_CONDITION_1]">{{'CLIENT_CONDITION_1' | translate}}
                        <a href="javascript:"
                           *ngIf="extended[clauseType.CLIENT_CONDITION_1] === false"
                           (click)="extended[clauseType.CLIENT_CONDITION_1] = true"
                           class="link link-accent">{{'READ_MORE' | translate}}</a>
                    </app-checkbox>
                </div>
            </div>
            <p class="checkbox-extend" *ngIf="extended[clauseType.CLIENT_CONDITION_1]">
                {{'CLIENT_CONDITION_1_EXTENDED' | translate }}
            </p>

            <div class="form-row">
                <div class="col">
                    <app-checkbox
                            [(ngModel)]="offer.additionalData.clauseMap[clauseType.CLIENT_CONDITION_2]"
                            [disabled]="readonly"
                            [errorStateMatcher]="matchers[clauseType.CLIENT_CONDITION_2]">{{'CLIENT_CONDITION_2' | translate}}
                        <a href="javascript:"
                           *ngIf="extended[clauseType.CLIENT_CONDITION_2] === false"
                           (click)="extended[clauseType.CLIENT_CONDITION_2] = true"
                           class="link link-accent">{{'READ_MORE' | translate}}</a>
                    </app-checkbox>
                </div>
            </div>
            <p class="checkbox-extend" *ngIf="extended[clauseType.CLIENT_CONDITION_2]">
                {{'CLIENT_CONDITION_2_EXTENDED' | translate }}
            </p>
        </div>
    </div>
</div>
